export default __webpack_public_path__ + "static/media/Twitter.4f7b6302.svg";